import { render, staticRenderFns } from "./DashboardRankingVendas.vue?vue&type=template&id=075a83e4"
import script from "./DashboardRankingVendas.vue?vue&type=script&lang=js"
export * from "./DashboardRankingVendas.vue?vue&type=script&lang=js"
import style0 from "./DashboardRankingVendas.vue?vue&type=style&index=0&id=075a83e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports